import React from 'react';
import { ChartArrow } from '../ChartArrow';
import { makeStyles } from '@material-ui/styles';
import { useItemAlertClick } from '../../../InventoryWidget/useItemAlertClick';
const useStyles = makeStyles(() => ({ label: { cursor: 'pointer', fontSize: 14 } }));
export const AlertBarChartLabel = (props) => {
    const { x, width, value: { deviationPerc, alertCount, id }, link, widget, } = props;
    const radius = 12;
    const cx = x + width / 2;
    const cy = deviationPerc > 0 ? 98 : 63;
    const limit = 20;
    const classes = useStyles();
    const onBarClick = useItemAlertClick();
    const showArrow = Math.abs(deviationPerc) > limit;
    const onClick = () => {
        onBarClick(id, link, widget);
    };
    return (React.createElement("g", { className: classes.label, onClick: onClick },
        React.createElement("circle", { cx: cx, cy: cy, r: radius, fill: "none", stroke: "black", strokeWidth: "2" }),
        React.createElement("text", { x: cx, y: cy + 2, fill: "#000", textAnchor: "middle", dominantBaseline: "middle" }, alertCount),
        showArrow && React.createElement(ChartArrow, { cx: cx, deviation: deviationPerc, yPositions: [10, 450], barWidth: width })));
};
//# sourceMappingURL=AlertBarChartLabel.js.map